import _ from 'lodash';
import React, { useEffect, useState } from 'react';
import { hot } from 'react-hot-loader/root';
import { from } from 'rxjs';
import { mergeMap, catchError, tap, finalize } from 'rxjs/operators';
import "../../../sass/main.scss";
import { createLead } from "../../api/dedupeApi";
import { getVisitTrackingInfo } from "../../api/ecomApi";
import { getUserDetails } from "../../api/userDetailsApi";
import {
    setAdobeFormSubmittedEvent,
    setAdobeLeadResponseReceivedEvent
} from "../../utilities/digitalDataUtils";
import { getDefaultFormValues } from '../../utilities/formUtilities';
import WelcomeForm from './welcomeForm';
import Loader from '../../components/loader';


const { debounce } = _;

function WelcomeFormContainer() {
    const [apiCallSucceeded, setApiCallSucceeded] = useState(false);
    const [data, setData] = useState(getDefaultFormValues());
    const [formPrefillLoading, setFormPrefillLoading] = useState(true);
    const [isLoading, setIsLoading] = useState(false);
    const [apiCallRetrieved, setApiCallRetrieved] = useState(false);
    const [visitTrackingInfo, setVisitTrackingInfo] = useState(null);

    useEffect(() => {
        const subscription = from(getVisitTrackingInfo()).pipe(
            tap((visitTrackingResponse) => {
                setVisitTrackingInfo(visitTrackingResponse);
            }),
            catchError(() => {
                // set to empty to allow user to continue on error
                setVisitTrackingInfo({});
                // Return an empty observable to continue the chain
                return from([]);
            }),
            mergeMap(() => from(getUserDetails())),
            finalize(() => setFormPrefillLoading(false))
        ).subscribe((userDetailsResponse) => {
            if (userDetailsResponse.email) {
                setData(getDefaultFormValues(userDetailsResponse));
            }
        }, () => {
            setFormPrefillLoading(false);
        });

        return () => {
            subscription.unsubscribe();
        };
    }, []);

    const submitForm = (data) => {
        setData(data);

        setApiCallSucceeded(false);
        setIsLoading(true);
        setApiCallRetrieved(false);

        let cidExists = data.campaignId && data.campaignId != "";

        setAdobeFormSubmittedEvent(data.hearAbout, cidExists);

        data.visitId = visitTrackingInfo && visitTrackingInfo.visitId ? visitTrackingInfo.visitId : null;

        createLead(data)
            .then((response) => {
                setApiCallSucceeded(response.leadCreated);
                setAdobeLeadResponseReceivedEvent(response.leadCreated, cidExists);
            })
            .catch((error) => {
                setApiCallSucceeded(false);
                setAdobeLeadResponseReceivedEvent(false, cidExists);
            })
            .finally(() => {
                setApiCallRetrieved(true);
                setIsLoading(false);
            });

    };

    const debounceSubmitForm = debounce(submitForm, 500, {
        'leading': true,
        'trailing': false
    });

    return (
        <>
            {formPrefillLoading ? <Loader />
                :
                <WelcomeForm
                    value={data}
                    onSubmit={debounceSubmitForm}
                    hideSubmitButton={(apiCallRetrieved && apiCallSucceeded) || isLoading || !visitTrackingInfo}
                    displayMessage={apiCallRetrieved}
                    apiCallStatus={apiCallRetrieved}
                    apiCallSuccess={apiCallSucceeded}
                    visitId={visitTrackingInfo && visitTrackingInfo.visitId ? visitTrackingInfo.visitId : null}
                />}
        </>
    );
}

export default hot(WelcomeFormContainer);